import React, { useState } from 'react';
import APIConfigModal from './APIConfigModal';

const Navbar = ({ user, onLogout, hasAPIKeys, onOpenAIChatPrompt }) => {
  const [isAPIConfigOpen, setIsAPIConfigOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar corporate-theme">
      <div className="nav-container">
        <div className="navbar-brand">
          <h1>LA SOIRÉE DU RIRE</h1>
          <p>de Granby</p>
        </div>
        
        {/* Desktop Navigation */}
        <ul className="navbar-nav">
          <li><a href="#dashboard" className="nav-link">Tableau de Bord</a></li>
          <li><a href="#analytics" className="nav-link">Analyses</a></li>
          <li><a href="#reports" className="nav-link">Rapports</a></li>
          <li><a href="#settings" className="nav-link">Paramètres</a></li>
        </ul>
        
        {/* Desktop Actions */}
        <div className="nav-actions desktop-actions animate-slideInRight">
          <div className="user-menu">
            <div className="user-info">
              {user?.avatar ? (
                <img 
                  src={user.avatar} 
                  alt="User" 
                  className="user-avatar"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '2px solid #f64a3e',
                    marginRight: '10px'
                  }}
                />
              ) : (
                <div 
                  className="user-avatar-placeholder"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#f64a3e',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    marginRight: '10px'
                  }}
                >
                  {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                </div>
              )}
              <span style={{ 
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1rem',
                fontWeight: '500',
                color: '#333'
              }}>
                {user?.name || 'Utilisateur'}
              </span>
            </div>
            <button 
              className="logout-btn hover-glow" 
              onClick={onLogout}
              style={{
                background: 'transparent',
                border: '2px solid #f64a3e',
                color: '#f64a3e',
                padding: '8px 16px',
                borderRadius: '6px',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '0.9rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#f64a3e';
                e.target.style.color = 'white';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#f64a3e';
              }}
            >
              Déconnexion
            </button>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-content">
          <div className="mobile-nav-links">
            <a href="#dashboard" className="mobile-nav-link" onClick={toggleMobileMenu}>
              <i className="fas fa-tachometer-alt"></i>
              Tableau de Bord
            </a>
            <a href="#analytics" className="mobile-nav-link" onClick={toggleMobileMenu}>
              <i className="fas fa-chart-line"></i>
              Analyses
            </a>
            <a href="#reports" className="mobile-nav-link" onClick={toggleMobileMenu}>
              <i className="fas fa-file-alt"></i>
              Rapports
            </a>
            <a href="#settings" className="mobile-nav-link" onClick={toggleMobileMenu}>
              <i className="fas fa-cog"></i>
              Paramètres
            </a>
          </div>
          
          <div className="mobile-nav-actions">
            <div className="mobile-user-menu">
              <div className="mobile-user-info">
                {user?.avatar ? (
                  <img 
                    src={user.avatar} 
                    alt="User" 
                    className="mobile-user-avatar"
                    style={{
                      width: '35px',
                      height: '35px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #f64a3e',
                      marginRight: '10px'
                    }}
                  />
                ) : (
                  <div 
                    className="mobile-user-avatar-placeholder"
                    style={{
                      width: '35px',
                      height: '35px',
                      borderRadius: '50%',
                      backgroundColor: '#f64a3e',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      marginRight: '10px'
                    }}
                  >
                    {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                  </div>
                )}
                <span style={{ 
                  fontFamily: 'Oswald, sans-serif',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  color: '#333'
                }}>
                  {user?.name || 'Utilisateur'}
                </span>
              </div>
              <button 
                className="mobile-logout-btn" 
                onClick={onLogout}
                style={{
                  background: 'transparent',
                  border: '2px solid #f64a3e',
                  color: '#f64a3e',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontFamily: 'Oswald, sans-serif',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f64a3e';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#f64a3e';
                }}
              >
                <i className="fas fa-sign-out-alt"></i>
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* API Configuration Modal */}
      <APIConfigModal 
        isOpen={isAPIConfigOpen}
        onClose={() => setIsAPIConfigOpen(false)}
      />
    </nav>
  );
};

export default Navbar;
